import { FC, ReactNode } from 'react';

import { CompactCollapsible } from '@/shared';

import { AlertFormSectionKey, alertFormStepsByKey } from '../../steps';

interface AlertFormSectionProps {
    children: ReactNode;
    description: ReactNode;
    headerExtra?: ReactNode;
    open: boolean;
    sectionKey: AlertFormSectionKey;
    onToggle: (section: AlertFormSectionKey) => void;
}

const AlertFormSection: FC<AlertFormSectionProps> = ({
    children,
    description,
    headerExtra,
    open,
    sectionKey,
    onToggle,
}) => {
    const section = alertFormStepsByKey[sectionKey];
    const SectionIcon = section.icon;

    return (
        <CompactCollapsible
            description={description}
            headerExtra={headerExtra}
            icon={<SectionIcon />}
            id={section.id}
            label={section.label}
            open={open}
            onOpenChange={() => onToggle(sectionKey)}
        >
            {children}
        </CompactCollapsible>
    );
};

export default AlertFormSection;
